<template>
    <div>
        <h4 class="mb-6">Channels</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addChannelPrompt = true">Add</vs-button>

        <vx-card>
            <vs-table id="table" ref="table" @selected="openChannel" pagination :max-items="itemsPerPage" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="category">Category</vs-th>
                    <vs-th sort-key="workers">Workers</vs-th>
                    <vs-th sort-key="epg_mapping">EPG Provider</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td style="width: 60px">
                                <img v-if="data[index].image_id.length > 0" style="height: 25px" :src="'/api/management/v1/channel_logo/' + data[index].image_id" :alt="data[index].name">
                            </vs-td>

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].category">
                                {{ data[index].category }}
                            </vs-td>

                            <vs-td :data="data[index].workers">
                                <vs-chip v-if="data[index].workers.length === 0" color="danger">Not used</vs-chip>
                                {{ data[index].workers }}
                            </vs-td>

                            <vs-td :data="data[index].epg_mapping">
                                <vs-chip v-if="data[index].epg_mapping === 'None'" color="danger">None</vs-chip>
                                <p v-else>{{ data[index].epg_mapping }}</p>
                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

        <vs-popup title="Add channel" :active.sync="addChannelPrompt">
            <div id="addChannelDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Logo</p>
                <img class="w-1/2 mb-3" v-if="!addLogoUploadOpen && addObject.image_id && addObject.image_id.length > 0" :src="'api/management/v1/channel_logo/' + addObject.image_id" alt="Logo">
                <br>
                <vs-button v-if="!addLogoUploadOpen && !(addObject.image_id && addObject.image_id.length > 0)" color="primary" class="mt-6; mr-1" @click="addLogoUploadOpen = true">Add logo</vs-button>
                <vs-button v-if="addObject.image_id && addObject.image_id.length > 0" color="danger" class="mt-6; mr-1" @click="removeLogo">Remove logo</vs-button>
                <vs-upload v-if="addLogoUploadOpen" text="Upload logo" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/channel_logo/'" @on-success="imageUploaded" />
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addChannel">Add</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    export default {
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                channels: [],
                addChannelPrompt: false,

                addObject: {},
                addLogoUploadOpen: false

            }
        },
        methods: {
            imageUploaded(data) {
                this.addLogoUploadOpen = false
                this.$set(this.addObject, 'image_id', data.target.response)
            },
            removeLogo() {
                this.$set(this.addObject, 'image_id', null)
            },
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/channel/')
                loadPromise.then(function(response) {
                    thisIns.channels = response.data
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            addChannel() {
                this.$vs.loading({
                    container: '#addChannelDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/channel/', {
                    name: this.addObject.name,
                    image_id: this.addObject.image_id
                })

                addPromise.then(function(response) {
                    thisIns.addChannelPrompt = false
                    thisIns.$printSuccess('Channel added')
                    thisIns.$vs.loading.close('#addChannelDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/channel/' + response.data.id)
                    })
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addChannelDiv > .con-vs-loading')
                })
            },
            openChannel(tr) {
                this.$router.push('/channel/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                return this.channels
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addChannelPrompt) {
                this.addChannelPrompt = false
                next(false)
            } else {
                next()
            }
        }

    }

</script>
